// @flow

import * as R from "ramda";
import transit from "transit-js";

import type { TransitMap } from "src/types";

import transitTypes from "./types";

const createHandler = type => (rep: TransitMap) =>
  new transitTypes[type]({
    label: rep.get("label"),
    importError: rep.get("importError"),
    autoCheck: rep.get("autoCheck"),
    settings: rep.get("settings"),
    excludeFromCollapse: rep.get("excludeFromCollapse")
  });

const readHandler = {
  text: createHandler("text"),
  number: createHandler("number"),
  date: createHandler("date"),
  user: createHandler("user"),
  pdf: createHandler("pdf"),
  file: createHandler("file"),
  select: createHandler("select"),
  form: createHandler("form"),
  approval: createHandler("approval"),
  revision: createHandler("revision"),
  richtext: createHandler("richtext"),
  ai: createHandler("ai"),
  conversation: (rep: TransitMap) => {
    const settings = !R.isEmpty(rep.get("settings"))
      ? JSON.parse(rep.get("settings"))
      : rep.get("settings");

    if (settings.child) {
      return new transitTypes.childConversation({
        label: rep.get("label"),
        importError: rep.get("importError"),
        autoCheck: rep.get("autoCheck"),
        settings: rep.get("settings"),
        excludeFromCollapse: rep.get("excludeFromCollapse")
      });
    }

    return new transitTypes.conversation({
      label: rep.get("label"),
      importError: rep.get("importError"),
      autoCheck: rep.get("autoCheck"),
      settings: rep.get("settings"),
      excludeFromCollapse: rep.get("excludeFromCollapse")
    });
  },
  section: (rep: TransitMap) => {
    const settings = !R.isEmpty(rep.get("settings"))
      ? JSON.parse(rep.get("settings"))
      : rep.get("settings");

    if (parseInt(settings.level || 0, 10) > 0) {
      return new transitTypes.subSection({
        label: rep.get("label"),
        autoCheck: rep.get("autoCheck"),
        settings: rep.get("settings")
      });
    }

    return new transitTypes.section({
      label: rep.get("label"),
      autoCheck: rep.get("autoCheck"),
      settings: rep.get("settings")
    });
  },
  link: (rep: TransitMap) =>
    new transitTypes.link({
      label: rep.get("label"),
      importError: rep.get("importError"),
      autoCheck: rep.get("autoCheck"),
      settings: rep.get("settings"),
      sourceProcessSettings: rep.get("sourceProcessSettings"),
      linkedProcessSettings: rep.get("linkedProcessSettings"),
      excludeFromCollapse: rep.get("excludeFromCollapse")
    }),

  // Old Transit Readers
  chatPickList: (rep: TransitMap) =>
    new transitTypes.chatPickList({
      label: rep.get("label"),
      isRequired: rep.get("isRequired"),
      placeholder: rep.get("placeholder"),
      isChecked: rep.get("isChecked"),
      settings: rep.get("settings")
    }),
  task: (rep: TransitMap) =>
    new transitTypes.task({
      label: rep.get("label"),
      isRequired: rep.get("isRequired"),
      placeholder: rep.get("placeholder"),
      isChecked: rep.get("isChecked")
    }),
  group: (rep: TransitMap) =>
    new transitTypes.group({
      label: rep.get("label"),
      isRequired: rep.get("isRequired"),
      placeholder: rep.get("placeholder"),
      isChecked: rep.get("isChecked")
    }),
  workflow: (rep: TransitMap) =>
    new transitTypes.workflow({
      label: rep.get("label"),
      isRequired: rep.get("isRequired"),
      placeholder: rep.get("placeholder"),
      isChecked: rep.get("isChecked"),
      settings: rep.get("settings")
    })
};

export default readHandler;

export const fieldTransitReader = transit.reader("json", {
  handlers: readHandler
});
